import { createContext, PropsWithChildren, useContext, useMemo } from "react"
import { ManagePartnersDialogDependencies } from "./types"

type ManagePartnersContextValue = ManagePartnersDialogDependencies

const ManagePartnersContext = createContext<ManagePartnersContextValue>(undefined)

export function ManagePartnersProvider({
    fieldSvc,
    session,
    shell,
    children,
}: PropsWithChildren<ManagePartnersContextValue>) {
    const value = useMemo<ManagePartnersContextValue>(() => ({ fieldSvc, session, shell }), [fieldSvc, session, shell])
    return <ManagePartnersContext.Provider value={value} children={children} />
}

export function useManagePartnersContext() {
    const value = useContext(ManagePartnersContext)
    if (value === undefined) {
        throw new Error("`useManagePartnersContext()` value is undefined.")
    }
    return value
}
